export default "__VITE_ASSET__316d5880__"